var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"label-success label"},[_vm._v(_vm._s(_vm.good))]),_vm._v(" "),_c('span',{staticClass:"label-danger label"},[_vm._v(_vm._s(_vm.bad))]),_vm._v(" "),_c('span',{staticClass:"label-default label"},[_vm._v("Total "+_vm._s(_vm.fileData.length))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca1846a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteBatchLabels.vue
// module id = 1764
// module chunks = 1